<template>
  <div class="modal fade1 in" id="modal-default" style="display: block;" :v-show="shwovalueEditCandidate">
      <div class="modal-dialog">
          <div class="modal-content">
              <div class="modal-header">
                  <button type="button" class="close" aria-label="Close">
                  <span aria-hidden="true" @click="closeEditCandidate()">×</span></button>
                  <h4>Edit Candidate Profile</h4>
              </div>
              <div class="modal-body">
                  <div class="card-body">
                      <b-form class="register-form" id="resets" v-on:submit.prevent="onSubmitCandidateProfile" novalidate>
                          <div class="col-md-12">
                              <input v-if="Boolean(editoption2)" type="submit" value="Save" style="width: 93px;height: 30px;" class="submit pull-right" name="submit" id="submit" />
                              <button v-if="Boolean(editoption1)" @click="changeedit()" style="width: 93px;height: 30px;font-size: 16px;padding: 2px;" class="btn btn-success pull-right">Edit</button>
                              <div v-if="Boolean(editoption2)">
                                  <button @click="cancel()" style="width: 93px;height: 30px;font-size: 16px;padding: 2px;" class="btn btn-default pull-right mr-2">Cancel</button>
                              </div>
                          </div>
                          <div class="row mt-2">
                              <div class="col-md-12 form-group">
                                  <label>Name</label>
                                  <b-form-input type="text" v-model.lazy.trim="$v.form.candidate_name.$model" :disabled="Boolean(editoption)" placeholder="Name*"  :state="chkState('candidate_name')"/>
                                  <div v-if="$v.form.candidate_name.$error">
                                    <p v-if="!$v.form.candidate_name.required" class="login-alert-msg error-content">* Enter the Name</p>
                                  </div>
                              </div>
                              <div class="col-md-12 mt-2 form-group">
                                  <label>Last Name</label>
                                  <b-form-input type="text" v-model.lazy.trim="$v.form.candidate_lastname.$model" :disabled="Boolean(editoption)" placeholder="Lastname" :state="chkState('candidate_lastname')"/>
                              </div>
                              <div class="col-md-12 mt-2 form-group">
                                  <label>Email</label>
                                  <b-form-input v-model.lazy.trim="$v.form.candidate_email.$model" :state="chkState('candidate_email')" :class="{'warningBorder' : (candidate_email === '' || candidate_email === null || candidate_email === undefined) , 'dangerBorder' : ((candidate_email === '' || candidate_email === null || candidate_email === undefined) && (candidate_mobile_number === '' || candidate_mobile_number === null || candidate_mobile_number === undefined))}" type="text" :disabled="Boolean(editoption)" placeholder="Email" />
                                  <div v-if="$v.form.candidate_email.$error">
                                    <p v-if="!$v.form.candidate_email.required" class="login-alert-msg error-content">* Enter the Email</p>
                                    <p v-if="!$v.form.candidate_email.email" class="login-alert-msg error-content">* Enter the valid Email</p>
                                  </div>
                              </div>
                              <div v-if="this.cnSh!= ''" class="col-md-12 mt-2 form-group">
                                  <label>Phone</label>
                                  <vue-tel-input
                                    class="form-control"
                                    id="ph_val"
                                    placeholder="Mobile Number"
                                    v-model.lazy.trim="$v.form.candidate_mobile_number.$model"
                                    @onInput="onInput"
                                    @input="Check"
                                    :default-country="getCnSh()"
                                    v-bind:class="{ 'is-invalid': !isValiedmobileNumber, 'dangerBorder':  (candidate_mobile_number === '' || candidate_mobile_number === null || candidate_mobile_number === undefined)}"
                                    :state="chkState('candidate_mobile_number')"
                                    :disabled="Boolean(editoption)"
                                  ></vue-tel-input>
                                  <div v-if="$v.form.candidate_mobile_number.$error">
                                    <p v-if="!$v.form.candidate_mobile_number.required" class="login-alert-msg error-content">* Enter the Mobile Number</p>
                                    <p v-if="!$v.form.candidate_mobile_number.minLength || !$v.form.candidate_mobile_number.maxLength || !$v.form.candidate_mobile_number.numeric" class="login-alert-msg error-content">* Enter the valid Mobile Number</p>
                                  </div>
                                  <!-- <label>Phone</label>
                                  <b-form-input v-model.lazy.trim="$v.form.candidate_mobile_number.$model" :state="chkState('candidate_mobile_number')" :class="{'dangerBorder' : (candidate_mobile_number === '' || candidate_mobile_number === null || candidate_mobile_number === undefined)}" type="text" :disabled="Boolean(editoption)" placeholder="Phone No." />
                                  <div v-if="$v.form.candidate_mobile_number.$error">
                                    <p v-if="!$v.form.candidate_mobile_number.required" class="login-alert-msg error-content">* Enter the Mobile Number</p>
                                    <p v-if="!$v.form.candidate_mobile_number.minLength || !$v.form.candidate_mobile_number.maxLength || !$v.form.candidate_mobile_number.numeric" class="login-alert-msg error-content">* Enter the valid Mobile Number</p>
                                  </div> -->
                              </div>
                          </div>
                      </b-form>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
import { BaseURLV3 } from '../shared/classes'
import { required, email, minLength, maxLength, numeric } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { VueTelInput } from 'vue-tel-input'
import parsePhoneNumberFromString from 'libphonenumber-js'

const optionsOverrides1 = {
  durations: {
    global: 3000
  },
  icons: {
    enabled: false
  },
  labels: {
    success: '',
    warning: '',
    alert: ''
  },
  position: 'bottom-right'
}

const formShape1 = {
  candidate_name: '',
  candidate_lastname: '',
  candidate_mobile_number: '',
  candidate_email: '',
  mobile_number_country_code: ''
}

export default {
  components: {
    VueTelInput
  },
  data () {
    return {
      editoption1: true,
      editoption2: false,
      editoption: true,
      mainurl: '',
      BaseURLV3: BaseURLV3,
      candidate_name: '',
      candidate_lastname: '',
      candidate_mobile_number: '',
      candidate_email: '',
      form: Object.assign({}, formShape1),
      isValiedmobileNumber: true,
      cnSh: ''
    }
  },
  props: [
    'data', 'shwovalueEditCandidate', 'postID'
  ],
  computed: {
    formStr () {
      return JSON.stringify(this.$v.form, null, 4)
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isDirty () {
      return this.$v.form.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      candidate_name: {
        required
      },
      candidate_lastname: {

      },
      candidate_mobile_number: {
        required,
        numeric,
        minLength: minLength(10),
        maxLength: maxLength(10)
        // mobile
      },
      candidate_email: {
        required,
        email
      }
    }
  },
  mounted () {
    this.setData()
  },
  methods: {
    onInput ({ number, isValid, country }) {
      this.isValiedmobileNumber = isValid
      this.form.mobile_number_country_code = country.dialCode
      this.form.candidate_mobile_number = number.significant
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    validate () {
      console.log('validate ')
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    checkNum (phoneNumber) {
      const regEx = /^[0-9]$/
      var num = phoneNumber % 10
      if (regEx.test(num)) {
        return true
      } else {
        return false
      }
    },
    Check (e) {
      if (!this.checkNum(e)) {
        this.isValiedmobileNumber = false
      }
    },
    setData () {
      this.form.candidate_name = this.data.first_name
      this.form.candidate_lastname = this.data.last_name
      this.form.candidate_mobile_number = this.data.mobile === null ? '' : this.data.mobile
      this.form.candidate_email = this.data.email === null ? '' : this.data.email
      this.form.mobile_number_country_code = this.data.mobile_country_code

      var countryShortName = ''
      countryShortName = parsePhoneNumberFromString('+' + this.data.mobile_country_code + this.data.mobile, { defaultCallingCode: '+' + this.data.mobile_country_code })
      if (countryShortName?.country !== undefined && countryShortName?.country !== null) {
        this.cnSh = (countryShortName?.country).toLowerCase()
      } else {
        this.cnSh = null
      }
      // this.candidate_name = this.data.first_name
      // this.candidate_lastname = this.data.last_name
      this.candidate_mobile_number = this.data.mobile
      this.candidate_email = this.data.email
    },
    getCnSh () {
      return this.cnSh
    },
    closeEditCandidate (reload = false) {
      var dat = {
        close: false,
        reload: reload
      }
      this.$emit('editCandidate_emit', dat)
    },
    changeedit () {
    // console.log('change')
      this.editoption = false
      this.editoption2 = true
      this.editoption1 = false
    },
    cancel () {
      this.editoption = true
      this.editoption2 = false
      this.editoption1 = true
    },
    onSubmitCandidateProfile () {
      // if (this.candidate_email == null || this.candidate_email === '') {
      //   this.$awn.alert('Please enter the email', optionsOverrides1)
      //   return
      // }
      if (this.validate()) {
        this.mainurl = '/org/' + this.data.id + '/' + this.postID + '/candidate_profile'
        var formData = {
          email: this.form.candidate_email,
          mobile: this.form.candidate_mobile_number,
          first_name: this.form.candidate_name,
          last_name: this.form.candidate_lastname,
          mobile_country_code: this.form.mobile_number_country_code
        }
        axios.post(BaseURLV3 + this.mainurl, formData, this.config).then(response => {
          if (response.data.success) {
            this.$awn.success('Candidate Details updated successfully')
            this.closeEditCandidate(true)
          } else {
            this.$awn.alert(response.data.msg, optionsOverrides1)
          }
        }).catch(e => {
          console.log(e)
        })
      } else {
        console.log('validation fail................')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.warningBorder{
border: #fad475 !important;
border-width: 1px !important;
border-style: solid !important;
box-shadow: 1px 1px 3px 0.2px #fad475;
}
.dangerBorder {
border: rgb(255, 0, 0) !important;
border-width: 1px !important;
border-style: solid !important;
box-shadow: 1px 1px 3px 0.2px rgb(248, 140, 94);
}
.vue-tel-input {
  padding: 0px !important;
}

</style>
